<template>
  <Form v-slot="{ errors }" @submit="onSubmit">
    <div class="my-3 text-center">
      <div
        class="bg-gray-450 p-4 md:w-full pl-6 rounded-full w-8/12 xs:w-full sm:w-full lg:w-10/12 flex items-center"
        :class="{ active: isActive }"
      >
        <Field
          name="paymentMethod"
          type="radio"
          value="telmex"
          class="mr-3"
          :model-value="modelValue"
          @update:model-value="$emit('update:modelValue', $event)"
        />
        <label for="paymentMethod" class="font-medium">Recibo telefónico Telmex</label>
      </div>
      <div
        v-if="isActive"
        class="bg-gray-450 md:w-full p-4 pt-6 pl-6 rounded-br-3xl rounded-bl-3xl transition-all"
      >
        <p class="text-sm">
          Ingresa el número telefónico al que está registrado tu
          <span class="font-bold"> Recibo Telmex </span> para pagar mensualmente.
        </p>
        <p class="underline mt-4">Número Telefónico (10 dígitos)*</p>
        <Field
          name="telmex"
          type="text"
          v-maska="'#### - #### - ##'"
          class="bg-white font-gray-900 xs:w-full sm:w-full p-4 my-3 rounded-full w-8/12"
          placeholder="0000 - 0000 - 00"
          :rules="isRequiredTenDigits"
        />
        <div>{{ errors.telmex }}</div>
        <div class="xs:flex xs:flex-col">
          <button
            type="submit"
            class="btn btn-red my-5 xs:self-center sm:self-center xs:w-8/12 sm:w-8/12"
          >
            Verificar
          </button>
        </div>
      </div>
    </div>
  </Form>
</template>

<script setup>
import { computed } from 'vue';
import { Form, Field } from 'vee-validate';
import { maska } from 'maska';
import { useValidation } from '../composables/useValidation';

const props = defineProps({
  modelValue: String,
  onSubmit: Function
});

defineEmits(['update:modelValue']);

const { isRequiredTenDigits } = useValidation();
const isActive = computed(() => props.modelValue === 'telmex');
</script>

<style scoped>
.active {
  @apply rounded-br-none rounded-bl-none bg-red text-white rounded-tr-2xl rounded-tl-2xl w-full;
}
</style>
